import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, LogIn } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import '../styles/AdminLogin.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.email || !credentials.password) {
      toast.error('Please enter email and password');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/auth/login`, credentials);
      const { access_token } = response.data;
      
      // Store token
      localStorage.setItem('mwp_admin_token', access_token);
      
      toast.success('Welcome back!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid email or password');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-container">
        <div className="login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_daa53b2c-a32e-47fc-b8be-c3729304beb0/artifacts/d3h4utx6_MWP%20Label%20Logo.png" 
            alt="Made With Purpose" 
            className="login-logo"
          />
          <h1>ADMIN LOGIN</h1>
          <p>Access your dashboard</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">
              <Mail size={18} />
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleInputChange}
              placeholder="admin@madewithpurpose.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <Lock size={18} />
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="btn-primary btn-full" disabled={isSubmitting}>
            <LogIn size={20} />
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <button onClick={() => navigate('/')} className="back-btn">
          ← Back to Website
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;